<div
  *ngIf="show"
  class="message"
  [ngClass]="{
    success: kind === 'success',
    error: kind === 'error'
  }"
>
  <button *ngIf="errors?.length" class="close-btn" (click)="close()">✕</button>
  <span>{{ message | translate : variable }}</span>
  <ul *ngIf="errors?.length">
    <li *ngFor="let error of errors">
      {{ 'PRE-WINNERS.PREWINNERS-UPLOAD.' + error.code | translate : error.params }}
    </li>
  </ul>
</div>
